import LoginBgOptimized from '../../assets/status-images/optimized_high_quality.jpg';
import BigLogoCp from '../../assets/status-images/big-logo-cp.svg';
import DefaultMalware from '../../assets/status-images/default_malware_image.png';
import SomethingWentWrongDark from '../../assets/status-images/something-went-wrong-dark.svg';
import SomethingWentWrongLight from '../../assets/status-images/something-went-wrong-light.svg';
import EmptyDark from '../../assets/status-images/empty-dark.svg';
import EmptyLight from '../../assets/status-images/empty-light.svg';
import GoodNewsDark from '../../assets/status-images/good-news-dark.svg';
import GoodNewsLight from '../../assets/status-images/good-news-light.svg';
import NoDataFoundDark from '../../assets/status-images/no-data-found-dark.svg';
import NoDataFoundLight from '../../assets/status-images/no-data-found-light.svg';
import DefaultReportThumbnail from '../../assets/status-images/default-thumbnail.png';
import CampaignImage from '../../assets/status-images/campaign.png';
import ExternalSourceThumbnail from '../../assets/status-images/external-source.png';
import Unauthorized from '../../assets/status-images/unauthorized.png';
import NoImage from '../../assets/status-images/no-image.png';

export const Images = {
  LoginBgOptimized,
  BigLogoCp,
  DefaultMalware,
  SomethingWentWrongDark,
  SomethingWentWrongLight,
  EmptyDark,
  EmptyLight,
  GoodNewsDark,
  GoodNewsLight,
  NoDataFoundDark,
  NoDataFoundLight,
  DefaultReportThumbnail,
  CampaignImage,
  ExternalSourceThumbnail,
  Unauthorized,
  NoImage
};
